import { cn } from '@/lib/utils'
import { Layout } from 'lucide-react'

const ProjectCardSkeleton = () => (
  <div className="p-4 rounded-xl border border-gray-200 bg-white animate-pulse">
    <div className="relative">
      <div className="w-full aspect-video rounded-lg flex items-center justify-center bg-gray-100">
        <Layout className="w-8 h-8 text-gray-200" />
      </div>

      {/* Status badge skeleton */}
      <div className="absolute top-3 right-3">
        <div className="w-20 h-7 rounded-full bg-gray-100" />
      </div>
    </div>

    {/* Title skeleton */}
    <div className="h-7 bg-gray-100 rounded mt-4 mb-1 w-3/4" />

    {/* Date skeleton */}
    <div className="h-5 bg-gray-100 rounded mt-2 w-1/3" />

    {/* User info skeleton */}
    <div className="flex items-center gap-2 mt-3">
      <div className="w-6 h-6 rounded-full bg-gray-100" />
      <div className="h-5 bg-gray-100 rounded w-1/4" />
    </div>
  </div>
)

type ProjectListSkeletonProps = {
  maxColumns?: number
  count?: number
  showSkeletonHeader?: boolean
}

export const ProjectListSkeleton = ({
  count = 6,
  maxColumns: columns = 3,
  showSkeletonHeader = true,
}: ProjectListSkeletonProps) => {
  return (
    <div className="rounded-2xl bg-gradient-to-br from-white via-white to-gray-50 border border-gray-200/50 p-5 shadow-xl shadow-gray-200/50 backdrop-blur-xl">
      {showSkeletonHeader && (
        <>
          {/* Header skeleton */}
          <div className="mb-3">
            <div className="flex items-center gap-3 mb-1">
              <div className="w-8 h-8 rounded-lg bg-gray-100" />
              <div className="h-8 bg-gray-100 rounded w-48" />
            </div>
            <div className="h-5 bg-gray-100 rounded ml-[44px] w-56" />
          </div>

          {/* Filter buttons skeleton */}
          <div className="flex gap-2 mb-4 ml-[44px]">
            <div className="w-24 h-8 rounded-full bg-gray-100" />
            <div className="w-24 h-8 rounded-full bg-gray-100" />
          </div>
        </>
      )}

      {/* Grid of skeleton cards */}
      <div
        className={cn('grid grid-cols-1 gap-4', {
          'md:grid-cols-2': columns >= 2,
          'lg:grid-cols-3': columns >= 3,
        })}
      >
        {[...Array(6)].map((_, i) => (
          <ProjectCardSkeleton key={i} />
        ))}
      </div>
    </div>
  )
}
